import React, { useState,useEffect } from 'react'
import Main from './Main'
import firebase from "firebase/app";
import moment from 'moment';

//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Reply from './Feedback/Reply';
import ContextDetails from './Context/ContextDetails';

function Feedback() {
    const [likedDetails, setLikedDetails] = useState({});
    const [auth, setAuth] = useState(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [rate, setRate] = useState({
        "1stStar": true,
        "2ndStar": true,
        "3rdStar": true,
        "4thStar": true,
        "5thStar": false
    });
    const [comment, setComment] = useState("");
    const [commentDetails, setCommentDetails] = useState([]);

    const setLikeDetails = () => {
        let likeDetails = {};
        commentDetails.forEach((item) => {
            likeDetails[item.email] = false
        });

        setLikedDetails(likeDetails);
    }

    const addFeedbackDetails = () => {
        let latestComment = [...commentDetails];
        let uploadedDate = moment().format("DD-MMM-YY");
        let likes = [];
        let replies = [];
        console.log("uploadedDate" + uploadedDate);
        const feedBackId = new Date().getTime();
        let rateCount = 0;
        for (let key in rate) {
            if (rate[key]) {
                rateCount++;
            }
        }
        if (name.trim() === "") {
            toast('Please put name!', {
                type: "error",
            });
        } else if (email.trim() === "") {
            toast('Please put email!', {
                type: "error",
            });
        } else if (comment.trim() === "") {
            toast('Please put message!', {
                type: "error",
            });
        } else if (rateCount === 0) {
            toast('Please rate star!', {
                type: "error",
            });
        } else {
            const regexForEmail = /\S+@\S+\.\S+/;
            try {
                if (regexForEmail.test(email)) {
                     firebase.database().ref('Feedback/' + feedBackId).set({
                        feedBackId,
                        uploadedDate,
                        rateCount,
                        name,
                        email,
                        comment,
                        likes : [],
                        replies
                     })
                    toast('Thanks for your valuable feedback!', {
                        type: "success",
                    });
                    latestComment.push({
                        feedBackId,
                        uploadedDate,
                        rateCount,
                        name,
                        email,
                        comment,
                        likes,
                        replies
                    });
                    setCommentDetails(latestComment);
                    setLikeDetails();
                    if (auth == null) {
                        setAuth({
                            name,
                            email
                        })
                    }
                    setName("");
                    setEmail("");
                    setComment("");
                    setRate({
                        "1stStar": true,
                        "2ndStar": true,
                        "3rdStar": true,
                        "4thStar": true,
                        "5thStar": false
                    })

                    console.log("comment " + latestComment);
                } else {
                    toast('Email is invalid or not exist', {
                        type: "error",
                    });
                }
            } catch (e) {
                toast('Oops something went wrong !', {
                    type: "error",
                });
            }
        }
    }

    const addReplies = (feedbackId, data) => {
        let repliesDetails = [...commentDetails];;
        repliesDetails.forEach((item, index) => {
            if (item.feedBackId === feedbackId) {
                if(!repliesDetails[index].replies){
                    repliesDetails[index].replies = [];
                }
                repliesDetails[index].replies.push(data);
            }
        })

        setCommentDetails(repliesDetails);
    }

    const addLike = (feedbackId, email) => {
        let repliesDetails = [...commentDetails];;
        repliesDetails.forEach((item, index) => {
            if (item.feedBackId === feedbackId) {
                repliesDetails[index].likes.push(email);
            }
        })

        setCommentDetails(repliesDetails);
    }

    const updateRate = (rateStar) => {
        setRate((prev) => {
            let changeData = { ...prev };
            changeData[rateStar] = !prev[rateStar];
            return changeData;
        })
    }

    useEffect(() =>{
        var tempData = [...commentDetails];
            firebase.database().ref('Feedback').on('value',   function(snapshot) {
                snapshot.forEach(function(childSnapshot) {
                    tempData.push(childSnapshot.val());
            })});
            console.log(tempData);
            setTimeout(() =>{
                setCommentDetails(tempData);
            },900)
    },[])

    return (
        <>
        {console.log("render is called")}
            <Main active="feedback">
                <ToastContainer />
                <div className="main">
                    <section id="contact" className="contact" style={{ paddingBottom: "25px" }}>
                        <div className="container">

                            <div className="section-title">
                                <h2>Feedback</h2>
                                <p style={{ "fontSize": "18px" }}>Please provide your valuable feedback. Thanks in advance!</p>
                            </div>

                            <div className="row">
                                <div className="col-lg-12 mt-5 mt-lg-0 info">
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="name">Your Name<sup style={{ "color": "red" }}>*</sup></label>
                                            <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} className="form-control" id="name" />
                                            <div className="validate"></div>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="name">Your Email<sup style={{ "color": "red" }}>*</sup></label>
                                            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} name="email" id="email" />
                                            <div className="validate"></div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Rate<sup style={{ "color": "red" }}>*</sup></label>
                                        <br></br>
                                        <span className={rate["1stStar"] ? "fa fa-star rate checked-rate" : "fa fa-star rate"} onClick={() => { updateRate("1stStar") }}></span>
                                        <span className={rate["2ndStar"] ? "fa fa-star rate checked-rate" : "fa fa-star rate"} onClick={() => { updateRate("2ndStar") }}></span>
                                        <span className={rate["3rdStar"] ? "fa fa-star rate checked-rate" : "fa fa-star rate"} onClick={() => { updateRate("3rdStar") }}></span>
                                        <span className={rate["4thStar"] ? "fa fa-star rate checked-rate" : "fa fa-star rate"} onClick={() => { updateRate("4thStar") }}></span>
                                        <span className={rate["5thStar"] ? "fa fa-star rate checked-rate" : "fa fa-star rate"} onClick={() => { updateRate("5thStar") }}></span>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Comments<sup style={{ "color": "red" }}>*</sup></label>
                                        <textarea className="form-control" name="message" value={comment} onChange={(e) => setComment(e.target.value)} rows="4"></textarea>
                                        <div className="validate"></div>
                                    </div>
                                    <div className="text-center"><button type="button" className="btn btn-primary" onClick={addFeedbackDetails}>Submit</button></div>
                                </div>
                                <div className="col-12" style={{ "borderTop": "1px solid gray", "marginTop": "30px", "paddingTop": "30px" }}>
                                    <h2 style={{ "color": "#173b6c", "marginBottom": "30px" }}>
                                        Comments :
                                    </h2>
                                    <ContextDetails.Provider value={likedDetails}>
                                        <div className="feedback-section">
                                            {
                                                commentDetails.map((item) => {
                                                    return <Reply key={item.feedBackId} data={item} auth={auth} addReplies={addReplies} addLike={addLike} />
                                                })
                                            }
                                        </div>
                                    </ContextDetails.Provider>
                                </div>

                            </div>

                        </div>
                    </section>
                </div>
            </Main>
        </>
    )
}

export default Feedback
